<template>
  <div>
    <el-card class="box-card" shadow="hover">
      <h2 slot="header">{{ $t('crm.vendorContacts') }}</h2>
      <el-table :data="tableData" border :header-cell-style="{backgroundColor: '#f0f0f0'}">
        <el-table-column :label="$t('crm.vendorContacts')">
          <template slot-scope="scope">
            {{ $t('crm.vendorContacts') }}{{ scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column prop="contactName" :label="$t('crm.mainContactName')"></el-table-column>
        <el-table-column prop="contactTitle" :label="$t('crm.mainContactTitle')"></el-table-column>
        <el-table-column :label="$t('crm.mainContact')">
          <template slot-scope="scope">
            <p v-for="(item, index) in scope.row.contactInformationList" :key="index">{{ item }}</p>
          </template>
        </el-table-column>
        <el-table-column prop="contactReponseSpeed" :label="$t('crm.mainContactReponseSpeed')"></el-table-column>
        <el-table-column prop="contactResponsibleFor" :label="$t('crm.mainContactResponsiblefor')"></el-table-column>
        <el-table-column prop="contactNegotitationStyle" :label="$t('crm.mainContactNegotitationStyle')"></el-table-column>
      </el-table>
    </el-card>

    <el-card class="box-card" shadow="hover">
      <h2 slot="header">{{ $t('crm.visitInfo') }}</h2>
      <div class="info-group">
        <div class="info-item">
          <label>{{ $t('crm.quarterlyF2FVisitFrequency') }}</label>
          <div class="value">{{ detail.quarterVisitCount || '-' }}</div>
        </div>
        <div class="info-item">
          <label>{{ $t('crm.otherVisitingFrequency') }}</label>
          <div class="value">{{ detail.otherVisitHabit || '-' }}</div>
        </div>
      </div>
    </el-card>

    <el-card class="box-card" shadow="hover">
      <h2 slot="header">{{ $t('crm.otherInfo') }}</h2>
      <div class="info-group">
        <div class="info-item full">
          <label>{{ $t('crm.mainContactIMOrderEmail') }}</label>
          <div class="value">{{ detail.pushOrderEmail || '-' }}</div>
        </div>
        <div class="info-item full">
          <label>{{ $t('crm.afterSaleNotifyEmail') }}</label>
          <div class="value">{{ detail.boutiqueAftermarketEmail || '-' }}</div>
        </div>
        <div class="info-item full">
          <label>{{ $t('crm.workOrderAutoEmai') }}</label>
          <div class="value">{{ detail.mailDefectLevelConfig || '-' }}</div>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
import { getVendorContactsList } from '../api';

export default {
  data() {
    return {
      detail: {},
      tableData: [],
    };
  },
  mounted() {
    getVendorContactsList({
      vendorId: this.$route.params.id,
    }).then((res) => {
      if (res.data.success && res.data.data) {
        this.detail = res.data.data;
        this.tableData = res.data.data.crmVendorContactsDetailDtos || [];
      }
    })
  },
}
</script>

<style lang="less" scoped>
.box-card {
  margin-bottom: 20px;
}
.info-group {
  display: flex;
  flex-wrap: wrap;
}
.info-item {
  display: flex;
  width: 50%;
  line-height: 20px;

  &.full {
    width: 100%;
  }

  label {
    flex: 0 0 auto;
    width: 200px;
    padding: 10px;
    background-color: #f9f9f9;
    border: 1px solid #EBEEF5;
  }
  .value {
    flex: 1;
    padding: 10px;
    border-top: 1px solid #EBEEF5;
    border-right: 1px solid #EBEEF5;
    border-bottom: 1px solid #EBEEF5;
  }

  &:nth-child(even) {
    label {
      border-left: 0;
    }
  }
  &:nth-child(n+3) {
    label {
      border-top: 0;
    }
    .value {
      border-top: 0;
    }
  }
}
</style>
